export type MedicalRecordLifecycleStatus = 'active' | 'invalidated';

export const getMedicalRecordAttachmentsObject = (
  recordAttachments: unknown,
): Record<string, any> => {
  if (
    recordAttachments &&
    typeof recordAttachments === 'object' &&
    !Array.isArray(recordAttachments)
  ) {
    return recordAttachments as Record<string, any>;
  }

  return {};
};

const hasAttachmentFileShape = (attachment: unknown): boolean => {
  if (!attachment) return false;

  if (typeof attachment === 'string') {
    return attachment.trim().length > 0;
  }

  if (typeof attachment !== 'object') {
    return false;
  }

  const candidate = attachment as Record<string, unknown>;

  return Boolean(
    candidate.url ||
    candidate.fileUrl ||
    candidate.downloadUrl ||
    candidate.signedUrl ||
    candidate.path
  );
};

export const isManualUploadedMedicalRecord = (
  recordAttachments?: unknown,
): boolean => {
  if (!Array.isArray(recordAttachments)) {
    return false;
  }

  return recordAttachments.some(hasAttachmentFileShape);
};

export const isMedicalRecordInvalidated = (
  recordType?: string | null,
  recordAttachments?: unknown,
): boolean => {
  const attachments = getMedicalRecordAttachmentsObject(recordAttachments);

  return (
    recordType === 'invalidated' ||
    (typeof recordType === 'string' && recordType.endsWith('_invalidated')) ||
    attachments.status === 'invalidated' ||
    Boolean(attachments.invalidation_info)
  );
};

export const getMedicalRecordLifecycleStatus = (
  recordType?: string | null,
  recordAttachments?: unknown,
): MedicalRecordLifecycleStatus => {
  return isMedicalRecordInvalidated(recordType, recordAttachments)
    ? 'invalidated'
    : 'active';
};

export const buildInvalidatedMedicalRecordAttachments = (
  recordAttachments: unknown,
  invalidationInfo: Record<string, any>,
  recordType?: string | null,
): Record<string, any> => {
  const attachments = getMedicalRecordAttachmentsObject(recordAttachments);
  const currentHistory = Array.isArray(attachments.invalidation_history)
    ? attachments.invalidation_history
    : [];

  return {
    ...attachments,
    status: 'invalidated',
    originalRecordType: attachments.originalRecordType || recordType || null,
    invalidation_info: invalidationInfo,
    invalidation_history: [...currentHistory, invalidationInfo],
  };
};
